import { SortOrder } from "shared/types/SortOrder"

export function getNextSortOrder(currentSortOrder?: SortOrder | null) {
  switch (currentSortOrder) {
    case SortOrder.ASC:
      return SortOrder.DESC
    case SortOrder.DESC:
      return null
    default:
      return SortOrder.ASC
  }
}
